<script lang="ts">
  import WelcomeNotification from "$components/community/WelcomeNotification.svelte";
  import { navigating, page } from "$app/stores";
  import Analytics from "$components/+headless/Analytics.svelte";
  import Notifications from "$components/+layout/Notifications.svelte";
  import UserPreferences from "$components/+headless/UserPreferences.svelte";
  import { emailNotVerified, insideAuthFlow, session } from "$stores/auth";
  import CommunityLoginModal from "app/pages/CommunityServerPage/CommunityLoginModal.svelte";
  import { browser } from "$app/environment";
  import { assets } from "$app/paths";
  import { onMount, setContext } from "svelte";
  import CreateCommunityModal from "$components/community/forms/CreateCommunityModal.svelte";
  import { goto } from "$app/navigation";
  import { convertToCanonicalUrl, verifyEmailUrl } from "$utils/urls";
  import { userStore } from "app/stores/user";
  import { userPreferencesStore } from "app/stores/userPreferences";
  import Shortcuts from "../components/+headless/Shortcuts.svelte";
  import "../app.css";

  export let data;

  const user = userStore(data.userData);
  const preferences = userPreferencesStore(user);

  setContext("user", user);
  setContext("userPreferences", preferences);

  onMount(() => {
    session.trackUTM($page.url);
  });

  $: canonicalUrl = convertToCanonicalUrl($page.url);

  // redirect users if email not verified (and not already navigating to/on the verify-email page)
  $: if (
    $session.signInProvider !== "custom" &&
    !$insideAuthFlow &&
    $emailNotVerified &&
    !$navigating &&
    !$page.route.id?.includes("verify-email") &&
    // never redirect widget users (if all other checks fail)
    !$page.route.id?.startsWith("/[community=slug]/widget")
  ) {
    goto(`${verifyEmailUrl()}/?next=${canonicalUrl}`);
  }
</script>

<UserPreferences />
<Analytics usingSubdomain={data.usingSubdomain} />
<svelte:head>
  <!-- Favicon -->
  {#if $page.data.og.icon}
    <link rel="icon" href="{$page.data.og.icon}-/format/png/-/preview/160x160/favicon.png" />
  {:else}
    <link rel="icon" href="{assets}/favicon.ico" />
  {/if}

  <!-- Title/Description -->
  <title>{$page.data.og.title}</title>
  <meta name="description" content={$page.data.og.description} />
  <meta name="theme-color" content="#000000" />
  <!-- Opengraph social tags -->
  <meta property="og:title" content={$page.data.og.title} />
  <meta property="og:description" content={$page.data.og.description} />
  {#if $page.data.og.image}
    <meta property="og:image" content={$page.data.og.image} />
  {/if}
  <meta property="og:url" content={$page.url.toString()} />
  <meta property="og:type" content="website" />

  <!-- Twitter card -->
  <meta name="twitter:title" content={$page.data.og.title} />
  <meta name="twitter:site" content={$page.url.toString()} />
  <meta name="twitter:description" content={$page.data.og.description} />
  {#if $page.data.og.image}
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:image" content={$page.data.og.image} />
  {:else}
    <meta name="twitter:card" content="summary" />
  {/if}

  <!-- Self Referencing Canonical URL -->
  {#if canonicalUrl.origin && canonicalUrl.pathname}
    <link rel="canonical" href={canonicalUrl.origin + canonicalUrl.pathname} />
  {/if}
</svelte:head>

<!-- isolate is used to create a stacking context -->
<main data-sveltekit-preload-code="hover" data-sveltekit-preload-data="hover" class="isolate">
  {#if browser}
    <WelcomeNotification />
  {/if}

  <!-- if the user does not have a handle the onboarding modal opens up -->
  <CommunityLoginModal>
    <CreateCommunityModal>
      <Notifications />
      <div class="flex h-full min-h-dvh w-full flex-col sm:flex-row">
        <slot />
      </div>
    </CreateCommunityModal>
  </CommunityLoginModal>
</main>

<Shortcuts />
